import { VenueMinifiedType as ApiVenueMinifiedType } from 'src/api/generated/touring/types';
import { mapAddress } from '../common';
import { VenueMinifiedType } from './types';

export const mapVenueMinifiedType = (
  apiVenue: ApiVenueMinifiedType
): VenueMinifiedType => {
  return {
    id: apiVenue.id,
    name: apiVenue.name,
    category: apiVenue.category,
    capacity: apiVenue.capacity ?? null,
    address: mapAddress(apiVenue.address),
  };
};
